import * as Animate from "react-reveal";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import Avatar1 from "../../../assets/images/png/avatars/1.webp";
import Avatar2 from "../../../assets/images/png/avatars/2.webp";
import Avatar3 from "../../../assets/images/png/avatars/3.webp";
import Avatar4 from "../../../assets/images/png/avatars/4.webp";

const heroStats = [
  { value: "12+", label: "countries supported" },
  { value: "1", label: "coordinated payroll flow" },
  { value: "Human", label: "support throughout" },
];

const flow = [
  { label: "Team added", state: "1" },
  { label: "Details checked", state: "2" },
  { label: "Payroll reviewed", state: "3" },
  { label: "Payout", state: "4" },
];

const people = [
  {
    img: Avatar1,
    name: "Wanjiku N.",
    role: "Product Designer",
    status: "Ready",
  },
  {
    img: Avatar2,
    name: "Amara O.",
    role: "Data Engineer",
    status: "Review",
  },
  {
    img: Avatar3,
    name: "David K.",
    role: "Product Manager",
    status: "Ready",
  },
];

const markStyle = {
  background: "linear-gradient(transparent 66%, #fbaf1be6 0)",
  padding: "0 0.08em",
  color: "inherit",
};

const PayHeaderSection = () => {
  return (
    <header
      className="w-full relative bg-white overflow-hidden"
      id="top"
      style={{
        backgroundImage: "linear-gradient(130deg, #fff 0 52%, #f1f4ff 52%)",
      }}
    >
      <HeaderNavigation />

      <div
        className="container mx-auto grid pay-grid-hero gap-10 lg:gap-[72px] items-center py-14 lg:py-[88px] px-6 lg:px-8"
        style={{ minHeight: "780px" }}
      >
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 text-primary text-[15px] font-black tracking-[0.11em] uppercase mb-[22px]">
              <span className="w-10 h-[3px] bg-secondary inline-block shrink-0"></span>
              Utiva Pay · Global Payroll, Made Human
            </p>
            <h1
              className="text-primary tracking-[-0.065em] leading-[0.99] font-black mb-[27px] max-w-[720px]"
              style={{ fontSize: "clamp(54px, 5.4vw, 83px)" }}
            >
              Pay People Everywhere.{" "}
              <mark style={markStyle}>Keep It Personal.</mark>
            </h1>
            <p className="text-[#5c6274] max-w-[690px] text-xl leading-[1.7] mb-8">
              Coordinate payroll for remote employees and contractors across
              borders—with one clear process and real people beside you.
            </p>

            <div className="flex flex-wrap items-center gap-[22px]">
              <a
                href="https://app.utiva.co/signup?goal=workforce"
                target="_blank"
                rel="noreferrer noopener"
                className="bg-primary text-white rounded-xl inline-flex items-center justify-center gap-5 text-[16px] font-black px-5 py-[15px] hover:bg-[#03046b] hover:-translate-y-0.5 transition-all"
                style={{
                  minHeight: "56px",
                  boxShadow: "0 18px 38px rgba(5,7,148,0.18)",
                }}
              >
                Talk to a payroll specialist <span aria-hidden="true">↗</span>
              </a>
              <a
                href="#how-it-works"
                className="text-primary inline-flex items-center gap-[13px] text-[16px] font-black hover:text-[#03046b] transition"
                style={{ minHeight: "50px" }}
              >
                See how it works <span aria-hidden="true">↓</span>
              </a>
            </div>

            <div className="grid grid-cols-3 gap-[18px] border-t border-[#dce3f1] mt-[46px] pt-[27px]">
              {heroStats.map((stat) => (
                <span key={stat.label} className="grid gap-[5px]">
                  <strong className="text-primary text-[23px]">
                    {stat.value}
                  </strong>
                  <span className="text-[#5c6274] text-[15px] leading-[1.45]">
                    {stat.label}
                  </span>
                </span>
              ))}
            </div>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div
            aria-label="Utiva Pay payroll overview"
            className="border border-[#cfd8ee] border-t-[6px] border-t-secondary bg-white rounded-[27px] p-7"
            style={{ boxShadow: "0 35px 90px rgba(20,28,79,0.16)" }}
          >
            <header className="flex flex-col sm:flex-row sm:justify-between items-start sm:items-center gap-5 border-b border-[#dce3f1] pb-[22px]">
              <div>
                <p className="text-[#936100] tracking-[0.1em] uppercase text-[15px] font-black mb-[5px]">
                  Payroll Run
                </p>
                <h2 className="text-primary text-[30px] m-0">August 2026</h2>
              </div>
              <span className="text-[#16723b] bg-[#e9f8ee] rounded-full px-3 py-[9px] text-[15px] font-black whitespace-nowrap">
                Ready to review
              </span>
            </header>

            <div className="grid pay-grid-console-summary gap-3 py-6">
              <div className="bg-primary text-white rounded-2xl grid gap-[7px] p-[21px]">
                <span className="text-[15px]">Total payroll</span>
                <strong className="text-secondary text-[43px]">$360,450</strong>
                <small className="text-[#dce2ff] text-[15px]">
                  Across 4 currencies
                </small>
              </div>
              <div className="bg-[#edf2ff] rounded-2xl grid gap-[7px] p-[21px]">
                <span className="text-[15px] text-[#5c6274]">People</span>
                <strong className="text-primary text-[34px]">86</strong>
                <small className="text-[#5c6274] text-[15px]">
                  Employees + contractors
                </small>
              </div>
            </div>

            <div className="grid grid-cols-4 border-y border-[#dce3f1] py-[22px]">
              {flow.map((step, index) => {
                const complete = index < 3;
                return (
                  <div
                    key={step.label}
                    className="grid gap-2 justify-items-center text-center relative"
                  >
                    {index < flow.length - 1 && (
                      <span
                        className="absolute bg-[#d8deec] hidden sm:block"
                        style={{
                          height: "2px",
                          top: "16px",
                          left: "63%",
                          right: "-37%",
                          background: complete ? "#050794" : "#d8deec",
                        }}
                      />
                    )}
                    <span
                      className={`relative z-10 rounded-full grid place-items-center text-[15px] font-black ${
                        complete
                          ? "bg-primary border-primary text-white"
                          : "bg-white border-[#cad2e4] text-[#5c6274]"
                      }`}
                      style={{
                        width: "34px",
                        height: "34px",
                        border: "2px solid",
                        borderColor: complete ? "#050794" : "#cad2e4",
                      }}
                    >
                      {complete ? "✓" : step.state}
                    </span>
                    <p className="text-[#5c6274] text-[15px] font-extrabold m-0">
                      {step.label}
                    </p>
                  </div>
                );
              })}
            </div>

            <div className="grid py-[14px]">
              {people.map((person) => (
                <article
                  key={person.name}
                  className="grid pay-grid-console-person items-center gap-3 border-b border-[#edf0f6] py-[10px]"
                >
                  <img
                    src={person.img}
                    alt=""
                    className="rounded-full object-cover"
                    style={{ width: "48px", height: "48px" }}
                  />
                  <p className="grid gap-[3px] m-0">
                    <strong className="text-[#191a25] text-[16px]">
                      {person.name}
                    </strong>
                    <small className="text-[#5c6274] text-[15px]">
                      {person.role}
                    </small>
                  </p>
                  <span
                    className="rounded-[7px] px-[10px] py-[7px] text-[15px] font-black justify-self-end"
                    style={
                      person.status === "Ready"
                        ? { color: "#176e3b", background: "#edf8f1" }
                        : { color: "#875b00", background: "#fff4db" }
                    }
                  >
                    {person.status}
                  </span>
                </article>
              ))}
            </div>

            <footer className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-[18px] sm:justify-between">
              <div className="flex">
                {[Avatar1, Avatar2, Avatar3, Avatar4].map((img, index) => (
                  <img
                    key={img}
                    src={img}
                    alt=""
                    className="rounded-full border-[3px] border-white object-cover"
                    style={{
                      width: "37px",
                      height: "37px",
                      marginLeft: index === 0 ? 0 : "-10px",
                    }}
                  />
                ))}
              </div>
              <p className="grid gap-[3px] m-0">
                <strong className="text-primary text-[15px]">
                  Your Utiva payroll team
                </strong>
                <span className="text-[#5c6274] text-[15px]">
                  Reviewing this cycle with you
                </span>
              </p>
              <a
                href="https://app.utiva.co/signup?goal=workforce"
                target="_blank"
                rel="noreferrer noopener"
                className="bg-secondary text-primary rounded-[9px] inline-flex items-center justify-center px-[14px] py-[10px] text-[15px] font-black mt-3 sm:mt-0"
                style={{ minHeight: "44px" }}
              >
                Approve payroll →
              </a>
            </footer>
          </div>
        </Animate.Fade>
      </div>
    </header>
  );
};

export default PayHeaderSection;
